import React from 'react';

import {assert} from 'Asserts';
import getTestProps from 'test/lib/cypress/getTestProps';

import {indexToLetter, indexToNumber, indexToRomanNumeral} from './IndexToSymbol';
import {ListType} from './ListConstants';

interface ListSymbolProps {
  calculatedListIndex: number;
  checkHandler: (index: number, checked: boolean) => void;
  indentation: number;
  index: number;
  listType: ListType;
  locked: boolean;
}

export default class ListSymbol extends React.Component<ListSymbolProps> {
  checkHandler = (): void => {
    assert(
      [ListType.CHECKBOX_UNCHECKED, ListType.CHECKBOX_CHECKED].includes(this.props.listType),
      `checkHandler called on non-checkbox notepart: ${this.props.listType}`
    );
    this.props.checkHandler(this.props.index, this.props.listType !== ListType.CHECKBOX_CHECKED);
  };

  override render(): JSX.Element | null {
    if (this.props.listType === ListType.NUMBER) {
      return (
        <span
          {...getTestProps({component: 'ListSymbol', element: 'number', index: this.props.index.toString()})}
        >
          {(() => {
            switch (this.props.indentation % 3) {
              case 1:
                return indexToNumber(this.props.calculatedListIndex);
              case 2:
                return indexToLetter(this.props.calculatedListIndex);
              default:
                return indexToRomanNumeral(this.props.calculatedListIndex);
            }
          })()}
          .
        </span>
      );
    } else if (this.props.listType === ListType.BULLET) {
      return (
        <span
          {...getTestProps({component: 'ListSymbol', element: 'bullet', index: this.props.index.toString()})}
        >
          {(() => {
            switch (this.props.indentation % 3) {
              case 1:
                return '\u25CF'; // black circle
              case 2:
                return '\u25CB'; // white circle
              default:
                return '\u25A0';
            }
          })()}
        </span>
      ); // black square
    } else if ([ListType.CHECKBOX_CHECKED, ListType.CHECKBOX_UNCHECKED].includes(this.props.listType)) {
      return (
        <span>
          <input
            type="checkbox"
            {...getTestProps({
              component: 'ListSymbol',
              element: 'checkbox',
              index: this.props.index.toString(),
            })}
            checked={this.props.listType === ListType.CHECKBOX_CHECKED}
            onChange={this.checkHandler}
            disabled={this.props.locked}
          />
        </span>
      );
    }
    return null;
  }
}
